<template>
    <div class="layout_top">
        <div class="global-title">
            {{tittle}}
        </div>
        <div class="gloabal-info-box">
            <!-- <div style="width:48px;height:48px;border-radius:50%;background-color:#ffffff;position: absolute;margin-top:12px">
                <img src="@/assets/images/icon_gift.png" />
            </div> -->
             <img src="@/assets/images/icon_gift.png"  style="position: absolute;margin-top:12px"/>
            <span style="margin-left: 60px;">{{desc}}</span>
        </div>
    </div>
</template>

<script>
export default {
    computed:{
        tittle(){
            return this.$route.name
        },
        desc(){
            return this.$route.meta.desc
        },
    }
}
</script>

<style>

</style>